import React from 'react';
import {
    Card,
    Stack,
    Typography,
    Checkbox,
    Chip,
    Box,
    Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { User, statusColors } from '../types/UserTypes';

interface UserCardProps {
    user: User;
    isSelected: boolean;
    onSelect: (userId: number, selected: boolean) => void;
}

const UserCard: React.FC<UserCardProps> = ({ user, isSelected, onSelect }) => {
    const navigate = useNavigate();

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSelect(user.id, event.target.checked);
    };

    const handleEdit = () => {
        navigate(`/edit-user/${user.apiId}`);
    };

    return (
        <Card
            elevation={3}
            sx={{
                borderRadius: 1,
                backgroundColor: '#FAF9F9',
                p: 2,
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                border:"2px solid #F2F0F0;"
            }}
        >
            <Stack spacing={1}>
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Checkbox 
                        checked={isSelected}
                        onChange={handleSelect}
                    />
                    <Chip
                        sx={{
                            color: statusColors[user.status].color,
                            backgroundColor: statusColors[user.status].bg,
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: 12,
                            borderRadius: '15px',
                            px: 1.5,
                            fontWeight: 600,
                            height: 30,
                        }}
                        size='small'
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Box
                                    sx={{
                                        width: 7,
                                        height: 7,
                                        borderRadius: '50%',
                                        backgroundColor: statusColors[user.status].color,
                                    }}
                                />
                                <span>{user.status}</span>
                            </Box>
                        }
                    />
                </Stack>

                <Divider />

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography
                        fontWeight={600}
                        fontSize={14}
                        fontFamily='Poppins, sans-serif'
                        sx={{ color: '#2979F1', textDecoration: 'underline' }}
                    >
                        {user.username}
                    </Typography>

                    <Typography
                        onClick={handleEdit}
                        sx={{
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#2979F1',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            ml: 2,
                            whiteSpace: 'nowrap',
                        }}
                    >
                        Edit
                    </Typography>
                </div>

                <Stack spacing={0.5}>
                    {user.roles.map((role, i) => (
                        <Chip
                            key={i}
                            label={role}
                            size='small'
                            sx={{
                                fontFamily: 'Poppins, sans-serif',
                                fontSize: 12,
                                backgroundColor: '#ECECEC',
                                color: '#203A6B',
                                borderRadius: '13px',
                                fontWeight: '600',
                                width: 'fit-content',
                            }}
                        />
                    ))}
                </Stack>

                <Typography fontSize={12} fontFamily='Poppins, sans-serif'>
                    Last Changed: {user.changed}
                </Typography>
                <Typography fontSize={12} fontFamily='Poppins, sans-serif'>
                    Last Access: {user.access}
                </Typography>
            </Stack>
        </Card>
    );
};

export default UserCard; 